import { AppConfig } from '@/utils/AppConfig';
import { getLocaleDate } from '@/utils/DateUtils';

const CurrentDate = () => {
  const currentDate = getLocaleDate(AppConfig.serverDate, true);

  return (
    <div className="mb-3.5 px-4 text-base text-grey-800 dark:text-white lg:mb-4 lg:px-0 lg:text-lg xl:mb-7 xl:text-xl">
      <h2 className="inline-block text-xl font-medium text-grey-900 dark:text-white xl:text-2xl">Сейчас,</h2>{' '}
      {currentDate}
    </div>
  );
};

export default CurrentDate;
